import React, {createContext, useCallback, useContext} from 'react';
import {KeycloakContext} from "./KeycloakContext";

const IconContext = createContext();

const IconContextProvider = ({ children }) => {
    const { updateTokenAndFetch } = useContext(KeycloakContext);

    const getIcon = useCallback(async (fileId) => {

        try {
            const response = await updateTokenAndFetch(`/files/${fileId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                cache: "force-cache"
            });
            if (response.ok) {
                const blob = await response.blob();
                return URL.createObjectURL(blob);
            }
        } catch (error) {
            console.error('Error fetching icon:', error);
            return null;
        }
    }, [updateTokenAndFetch]);

    return (
        <IconContext.Provider value={{ getIcon }}>
            {children}
        </IconContext.Provider>
    );
}

export {IconContextProvider, IconContext};
